import CustomLottie from '@/components/custom-lottie';
import { LottiesContext } from '@/pages/(gapsdk)/_provider/lotties-provider';
import { SoundContext } from '@/pages/(gapsdk)/_provider/sound-provider';
import {
  isTypeOfAmericanExpress,
  isTypeOfDiscover,
  isTypeOfMasterCard,
  isTypeOfVisa,
} from '@/utils/check-type-card';
import { useContext, useEffect } from 'react';
import PaymentMasterCardSuccess from './payment-mastercard-successful';

const PaymentSuccess = (props: { onBack: () => void; cardType?: string }) => {
  const { event } = useContext(SoundContext);
  const lowerCaseCardType = props.cardType?.toLowerCase();

  const {
    amex,
    discover,
    visa,
    default: defaultSuccess,
  } = useContext(LottiesContext);

  useEffect(() => {
    if (isTypeOfAmericanExpress(lowerCaseCardType!)) {
      event.playPaymentSuccessAmex();
    } else if (isTypeOfDiscover(lowerCaseCardType!)) {
      event.playPaymentSuccessDiscover();
    } else if (isTypeOfVisa(lowerCaseCardType!)) {
      event.playPaymentSuccessVisa();
    } else if (isTypeOfMasterCard(lowerCaseCardType!)) {
      // TODO: nothing
    } else {
      event.playPaymentSuccess();
    }
  }, [lowerCaseCardType]);

  if (isTypeOfAmericanExpress(lowerCaseCardType!))
    return (
      <div className="relative flex size-full flex-col items-center">
        <CustomLottie
          className="size-full overflow-hidden"
          animationData={amex}
          onLoadComplete={props.onBack}
        />
      </div>
    );
  if (isTypeOfDiscover(lowerCaseCardType!))
    return (
      <div className="relative flex size-full flex-col items-center">
        <CustomLottie
          className="size-full overflow-hidden"
          animationData={discover}
          onLoadComplete={props.onBack}
        />
      </div>
    );

  if (isTypeOfMasterCard(lowerCaseCardType!))
    return <PaymentMasterCardSuccess onBack={props.onBack} />;

  if (isTypeOfVisa(lowerCaseCardType!))
    return (
      <div className="relative flex size-full flex-col items-center">
        <CustomLottie
          animationData={visa}
          className="size-full overflow-hidden"
          onLoadComplete={props.onBack}
        />
      </div>
    );

  return (
    <div className="relative flex size-full flex-col items-center bg-success">
      <div className="m-auto flex max-w-[480px] flex-col items-center justify-center gap-6">
        <CustomLottie
          className="size-[180px] overflow-hidden rounded-full border border-solid border-white"
          animationData={defaultSuccess}
          onLoadComplete={() => {
            props.onBack();
          }}
        />
        <h2 className="flex-none text-[32px] font-bold text-white">
          Payment Successful!
        </h2>
      </div>
    </div>
  );
};

export default PaymentSuccess;
